import { LootboxWidgets } from '../organisms/LootboxWidgets'
import { LootboxNavigation } from '../molecules/LootboxNavigation'
import { LootboxBanner } from '../organisms/LootboxBanner'
import { Collections } from '../organisms/Collections'

export const LootboxLanding = () => {
  return (
    <>
      <LootboxNavigation />
      <LootboxWidgets polling={true} />
      <LootboxBanner />
      <Collections />
    </>
  )
}
